var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"type":"plain"}},[_c('h2',{domProps:{"textContent":_vm._s(_vm.$t('Parallels Account Security Notice'))}}),_c('security-notice-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }